import {
  GridColumnMenuContainer,
  type GridColumnMenuProps,
  GridFilterMenuItem,
  SortGridMenuItems,
} from "@mui/x-data-grid-pro";

export function CustomColumnMenu(props: GridColumnMenuProps): JSX.Element {
  const { hideMenu, currentColumn, open } = props;

  return (
    <GridColumnMenuContainer
      hideMenu={hideMenu}
      currentColumn={currentColumn}
      open={open}
    >
      <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
      <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
    </GridColumnMenuContainer>
  );
}
